module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl2-50.a4dcbcc3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl2-50.png
// module id = 3301
// module chunks = 11